import ReactHead from '@hashicorp/react-head'
import CallToAction, {
	CallToActionProps,
} from '../../components/_page-components/customer-success/call-to-action'
import Hero, {
	HeroProps,
} from '../../components/_page-components/customer-success/hero'
import Intro, {
	IntroProps,
} from '../../components/_page-components/customer-success/intro'
import BenefitSection, {
	BenefitSectionProps,
} from '../../components/_page-components/customer-success/benefit-section'
import Courses, {
	CoursesProps,
} from '../../components/_page-components/customer-success/courses'
import PrivateCourseSection, {
	PrivateCourseSectionProps,
} from '../../components/_page-components/customer-success/private-course-section'
import s from './style.module.css'

interface SasEnterpriseAcademyPageProps {
	seo: {
		title: string
		description: string
		image: {
			url: string
		}
	}
	hero: HeroProps
	intro: Pick<IntroProps, 'heading' | 'items'>
	wsu: Pick<BenefitSectionProps, 'heading' | 'description' | 'benefits'>
	coursesSection: CoursesProps
	pcs: PrivateCourseSectionProps
	callToAction: Pick<CallToActionProps, 'heading' | 'content' | 'links'>
}

export default function SasEnterpriseAcademyPage({
	seo,
	hero,
	intro,
	wsu,
	coursesSection,
	pcs,
	callToAction,
}: SasEnterpriseAcademyPageProps) {
	return (
		<>
			<ReactHead
				title={seo.title}
				image={`${seo.image?.url}?fit=max&fm=jpg&w=1000`}
				description={seo.description}
				siteName={seo.title}
				twitterCard="summary_large_image"
			/>
			<div className={s.customerSuccess}>
				<Hero
					eyebrow={hero.eyebrow}
					heading={hero.heading}
					description={hero.description}
					cta={hero.cta}
					image={hero.image}
				/>

				<Intro heading={intro.heading} items={intro.items} />

				<BenefitSection
					heading={wsu.heading}
					description={wsu.description}
					theme="white"
					layout="horizontal"
					benefits={wsu.benefits}
				/>

				<Courses
					intro={coursesSection.intro}
					heading={coursesSection.heading}
					courses={coursesSection.courses}
				/>

				<PrivateCourseSection
					heading={pcs.heading}
					description={pcs.description}
					cta={pcs.cta}
					benefitListHeading={pcs.benefitListHeading}
					benefits={pcs.benefits}
				/>

				<CallToAction
					theme="blue"
					heading={callToAction.heading}
					content={callToAction.content}
					links={callToAction.links}
				/>
			</div>
		</>
	)
}
